<template>
  <div class="contact-component tr">
    <transition name="fade">
      <div class="contact tr bg-black white">
        <h1 class="close-icon pointer f1 purple-txt-invert b" @click="closeContact()">X</h1>
        <main class="w-100 ph3 pt3 pt3-m pb6 ph4-m ph4-ns pt4-ns pb0-ns tl">
          <div class="w-50-ns w-100-m w-100 fl-ns">
            <p class="contact-headline cf w-100 f-6-ns f2 f-5-m b mt0 mb0-m dib">I’m a <a class="contact-link white" href="https://open.spotify.com/artist/3RjD8uW4C691lIu1DKj0pK?si=QKAgat5QSq-wtBN4piYf9g" target="_blank">musician</a>, sound engineer and overall audio-oriented creative.</p>
          </div>
          <div class="contact-bio w-50 w-50-ns w-100-m w-100 fr-ns">
            <p class="cf w-100 f4 b mt0 dib">Born and raised in Greece, I've been an Amsterdam citizen since 2009.</p>
            <p class="cf w-100 f4 b mt0 dib">My expertise involves conceptualizing, supervising and leading the process of creation and execution of musical pieces, scores and soundtracks.</p>
            <p class="cf w-100 f4 b mt0 dib">I got to hone my skills in the independent music scene, as well as on a wide variety of commercial projects for global campaigns and brands &#8211; mainly during my tenure at 72andSunny Amsterdam, where I held the role of Music Lead for the better part of 6 years.</p>
            <p class="cf w-100 f4 b mt0 dib">What I enjoy the most about my work is learning from and collaborating with musicians, engineers & all kinds of creatives who want to realize a collective vision. What I enjoy even more is getting to spend time in recording studios.</p>
            <p class="cf w-100 f4 b mt0 mb4 dib">I’m also a software developer &mdash; you can check my work in that domain <a class="contact-link small white" href="https://inconsequentialcode.net" target="_blank">here</a>.</p>
            <p class="cf w-100 f4 b mt0 dib">Sometimes I like <a class="contact-link small white" href="https://www.facebook.com/1172420906173453/videos/324292864834302" target="_blank">playing records</a> too.</p>
            <p class="cf w-100 f4 b mt0 mb4 dib">You can get in touch with me <a class="contact-link small white" href="mailto:diamantisleonidas@gmail.com" target="_blank">here</a> or <a class="contact-link small white" href="https://www.linkedin.com/in/leonidas-diamantis-64660a37" target="_blank">here</a>.</p>
          </div>
        </main>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data: function () {
    return {
      showContact: false
    }
  },
  methods: {
    closeContact() {
      console.log('emitting close contact');
      this.$emit('closeContact');
    }
  },
  created() {
    let self = this;

    window.addEventListener('keyup', function(ev) {
      if (event.keyCode == 27) { //esc - hide contact overlay
        self.showContact = false;
      }
    });
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#lemon {
  position: absolute;
  bottom: 0px;
  left: 20px;
  z-index: 150;
  /*width: 100%;
  max-width: 100px;*/
  transition: transform .3s;
  cursor: pointer;
}

#lemon:hover { transform: scale(1.1); }

div.contact {
  overflow: scroll;
}

div.contact-component, div.contact {
  /*position: absolute;*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

div.contact {
  /*z-index: 100;*/
  /*background-color: rgba(255, 255, 255, 1);*/
  /*color: #f3eded;*/
  /*color: #000;*/
  background-image: url('~@/assets/contact-texture.png');
  background-size: cover;
}

.contact-headline {
  line-height: 1em;
}

.contact-bio {
  padding-top: 1rem;
}

.contact-link {
  /*border-bottom: 1px solid #78D308;*/
  position: relative;
  z-index: 2;
}

.contact-link:after {
  content: '';

  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0.3rem;
  z-index: 1;

  border-bottom: 2px solid #78D308;
}

.contact-link.small:after {
  bottom: 0rem;
}

.close-icon {
  position: fixed;
  /*left: 20px;*/
  left: 34px;
  bottom: 10px;
  /*top: 10px;*/
  z-index: 10;
}



/*ns breakpoint*/
@media screen and (min-width: 30em) {
  .contact-bio {
    padding-top: 11rem;
  }

  .contact-link:after {
    content: '';

    width: 100%;
    position: absolute;
    left: 0;
    bottom: 1rem;
    z-index: 1;

    border-bottom: 2px solid #78D308;
  }
}

/*medium breakpoint*/
@media screen and (min-width: 30em) and (max-width: 60em) {
  .contact-bio {
    padding-top: 4rem;
  }

  .contact-link:after {
    content: '';
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0.7rem;
    z-index: 1;
    border-bottom: 2px solid #78D308;
  }
}

</style>
